import { styled, Box, Theme, useTheme } from "@mui/material";

import * as Vibrant from "node-vibrant/dist/vibrant.js";
import React from "react";
import { hexToRgbString } from "../../../Utils/Helpers/cssUtils";

export interface HomeHeroBackgroundProps {
  covers: string[];
  visibleCoverIndex: number;
}

const defaultGradient = [
  "linear-gradient(176deg, rgba(46,54,82, 0.6) 8.39%, rgba(36,44,93, 0.5) 54.94%, rgba(16,16,24, 0.8) 77.32%)",
];

const HomeHeroBackgroundWrapper: React.FC<HomeHeroBackgroundProps> = (props) => {
  const { covers, visibleCoverIndex } = props;
  const [gradients, setGradients] = React.useState<string[]>([]);
  const theme = useTheme();

  const getGradients = React.useCallback(
    (covers: string[]) => {
      if (covers.length === 0) setGradients(defaultGradient);
      else {
        const _gradients: string[] = [];
        Promise.all(covers.map((cover) => Vibrant.from(cover).getPalette())).then((palettes: any[]) =>
          palettes.forEach((palette) => {
            let gradientMutedColor, gradientVibrantColor;
            if (theme.palette.mode === "dark") {
              gradientMutedColor = palette.DarkMuted.rgb.join(",");
              gradientVibrantColor = palette.DarkVibrant.rgb.join(",");
            } else {
              gradientMutedColor = palette.LightMuted.rgb.join(",");
              gradientVibrantColor = palette.LightVibrant.rgb.join(",");
            }
            _gradients.push(
              `linear-gradient(176deg, rgba(${gradientMutedColor}, 0.6) 8.39%, rgba(${gradientVibrantColor}, 0.5) 25%, rgba(${hexToRgbString(
                theme.palette.background.default
              )}, 0.8) 50%)`
            );
            setGradients(_gradients);
          })
        );
      }
    },
    [theme.palette.mode]
  );

  React.useEffect(() => {
    getGradients(covers);
  }, [getGradients, covers]);

  return (
    <HomeBackground>
      {gradients.map((gradient, index) => (
        <Gradient image={gradient} key={index} active={visibleCoverIndex === index} />
      ))}
    </HomeBackground>
  );
};

const HomeBackground = styled(Box)(({ theme }) => ({
  position: "absolute",
  height: "100%",
  width: "100%",
  overflow: "hidden",
}));

const Gradient = styled(Box, { shouldForwardProp: (prop) => prop !== "image" && prop !== "active" })<{
  image: string;
  active: boolean;
}>(({ theme, image, active }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: image,
  opacity: active ? 1 : 0,
  transition: "opacity .6s",
}));

const HomeHeroBackground = React.memo(HomeHeroBackgroundWrapper);
export default HomeHeroBackground;
